import { userSession } from '../auth';
import React from 'react';

export const InvalidUserMessage = () => {
  localStorage.removeItem('userData');
  return (
    <div className="container">
      <div className="row justify-content-md-center">
        <div className="col-12">
          <div className="py-5 my-5 text-center main-color">
            <h1 className="display-5 fw-bold">STACKS DEGENS</h1>

            <div className="second-color">
              <p className="lead mb-0 pt-3">INVALID USER. LOG OUT NOW</p>
              <hr className="divider" />

              <a
                href="#"
                className="text-decoration-none"
                style={{ outlineWidth: '0px !important', userSelect: 'auto !important' as any }}
                onClick={() => {
                  userSession.signUserOut();
                  window.location = '/' as any;
                }}
              >
                <p className="mb-0 lead"> Log out </p>
              </a>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
